var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwitchPatient = function SvgSwitchPatient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.818 5.502h-.485V1.335l.485 4.167Zm0 0a6.667 6.667 0 0 1 12.797 1.666M1.818 5.502H5.5m8.682 5h.485v4.166l-.485-4.166Zm0 0A6.67 6.67 0 0 1 1.385 8.835m12.797 1.667H10.5",
    stroke: "#2A2222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSwitchPatient;